import { Get_OSTAM, Get_SHAR, Get_COUNTRY, SIGN_REQUEST } from '../action/actionTypes'

const initialState = {
    countryList: null,
    ostanList: null,
    shahrList: null,
    signResult: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case Get_COUNTRY:
            return {
                ...state,
                countryList: action.countryList
            }
        case Get_OSTAM:
            return {
                ...state,
                ostanList: action.ostanList,
            }
        case Get_SHAR:
            return {
                ...state,
                shahrList: action.shahrList,
            }
        case SIGN_REQUEST:
            return {
                ...state,
                signResult: action.signResult
            }
        default:
            return state;
    }
};

export default reducer;